import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {

  dismiss(event) {
    event.preventDefault()

    Rails.ajax({
      url: `/app/${document.body.dataset.accountId}/auto_archive_notice/dismiss?id=${this.data.get("id")}`,
      type: "POST",
      success: () => {
        this.element.remove()
      },
      error: () => {
        toastr.error("Something went wrong, please try again.")
      }
    })
  }
}
